import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined"
import EditIcon from "@mui/icons-material/Edit"
import { Avatar, Box, Chip, Tooltip, Typography } from "@mui/material"
import type { BiomeshContactRef } from "@phc/common/gen/threatAnalyticsGen"
import { extraColors } from "../../../utils/theme"
import { ActionButton, CardRoot } from "./shared"

function formatContactName(contact: {
  rank?: string | null
  first_name: string
  last_name: string
}) {
  const parts = [contact.rank, contact.first_name, contact.last_name].filter(
    Boolean
  )
  return parts.join(" ")
}

function contactInitials(contact: { first_name: string; last_name: string }) {
  return `${contact.first_name[0] ?? ""}${contact.last_name[0] ?? ""}`
}

export function ContactCard({
  contact,
  via,
  onEdit,
  onDelete,
}: {
  contact: BiomeshContactRef
  via?: string[]
  onEdit?: () => void
  onDelete?: () => void
}) {
  return (
    <CardRoot sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
      <Avatar
        sx={{
          width: 36,
          height: 36,
          bgcolor: extraColors.status.navyMuted,
          color: extraColors.status.navyLight,
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        {contactInitials(contact)}
      </Avatar>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <Typography variant="body2Bold">
          {formatContactName(contact)}
        </Typography>
        {via && via.length > 0 && (
          <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mt: 0.5 }}>
            {via.map(label => (
              <Chip
                key={label}
                label={label}
                size="small"
                sx={{
                  height: 18,
                  fontSize: 10,
                  bgcolor: extraColors.dark5,
                  color: extraColors.medium,
                }}
              />
            ))}
          </Box>
        )}
        {contact.email && (
          <Typography variant="small1" sx={{ color: extraColors.hint }}>
            Email: {contact.email}
          </Typography>
        )}
        {contact.phone && (
          <Typography variant="small1" sx={{ color: extraColors.hint }}>
            Phone: {contact.phone}
          </Typography>
        )}
      </Box>
      {(onEdit || onDelete) && (
        <Box sx={{ display: "flex", gap: 0.5, ml: "auto" }}>
          {onEdit && (
            <Tooltip title="Edit contact">
              <ActionButton size="small" onClick={onEdit}>
                <EditIcon fontSize="small" />
              </ActionButton>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Delete permanently">
              <ActionButton size="small" onClick={onDelete}>
                <DeleteOutlineIcon fontSize="small" />
              </ActionButton>
            </Tooltip>
          )}
        </Box>
      )}
    </CardRoot>
  )
}
